import { render } from "./customCheckBox.vue?vue&type=template&id=2e4b4640&scoped=true"
import script from "./customCheckBox.vue?vue&type=script&lang=js"
export * from "./customCheckBox.vue?vue&type=script&lang=js"

import "./customCheckBox.vue?vue&type=style&index=0&id=2e4b4640&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4b4640"]])

export default __exports__